// lib/stripe.js
import { loadStripe } from '@stripe/stripe-js';

// Call loadStripe once and export the promise
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
export default stripePromise;